import { AppBar, Dialog, IconButton, Toolbar } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { Box, Button, TextBox } from '@superdispatch/ui-lab';
import {
  printHTMLContent,
  usePrintHTMLContent,
} from 'shared/hooks/usePrintHTMLContent';
import { PrinterIcon } from 'shared/icons/PrinterIcon';
import { LoadBOLPReviewParams, useLoadBOLPreview } from '../data/LoadsAPI';
import { PreviewBox } from './LoadInvoicePreviewDialog';
import { useSubhaulLoad } from '../view/useSubhaulLoad';

interface LoadBOLPreviewDialogContentProps {
  onClose: () => void;
  params: LoadBOLPReviewParams;
  loadGUID: null | string | undefined;
}

function LoadBOLPreviewDialogContent({
  params,
  onClose,
  loadGUID,
}: LoadBOLPreviewDialogContentProps) {
  const { isSubhauled } = useSubhaulLoad();
  const { data } = useLoadBOLPreview(loadGUID, params, isSubhauled);

  usePrintHTMLContent(data?.html || '');

  return (
    <>
      <AppBar position="fixed">
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="close"
            onClick={onClose}
          >
            <Close />
          </IconButton>
          <TextBox variant="heading-3">BOL Preview</TextBox>

          <Box marginLeft="auto">
            <Button
              variant="primary"
              startIcon={<PrinterIcon />}
              disabled={!data?.html}
              onClick={() => {
                if (data?.html) {
                  printHTMLContent(data.html);
                }
              }}
            >
              Save or Print PDF
            </Button>
          </Box>
        </Toolbar>
      </AppBar>

      <Box
        width="21cm"
        height="100%"
        marginLeft="auto"
        marginRight="auto"
        marginTop="xxlarge"
        marginBottom="small"
        paddingTop="xxlarge"
      >
        <PreviewBox
          id="bol-preview"
          //  eslint-disable-next-line @typescript-eslint/naming-convention
          dangerouslySetInnerHTML={{ __html: data?.html || '' }}
        />
      </Box>
    </>
  );
}

interface LoadBOLPreviewDialogProps extends LoadBOLPreviewDialogContentProps {
  open: boolean;
}

export function LoadBOLPreviewDialog({
  open,
  onClose,
  ...props
}: LoadBOLPreviewDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} fullScreen={true}>
      <LoadBOLPreviewDialogContent {...props} onClose={onClose} />
    </Dialog>
  );
}
